module.exports = __webpack_public_path__ + "img/lens-150-plus-07.c9fef8c8.png";